import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AddPipelineComponent } from "./add-pipeline/add-pipeline.component";
import { DeletePipelineComponent } from "./delete-pipeline/delete-pipeline.component";

@Component({
  selector: 'app-pipeline-configuration',
  standalone: true,
  imports: [CommonModule, SharedModule, AddPipelineComponent, DeletePipelineComponent],
  templateUrl: './pipeline-configuration.component.html',
  styleUrls: ['./pipeline-configuration.component.scss']
})
export class PipelineConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddPipeline: boolean = false;
  editPipelineData: any = null;
  isEditPipeline: boolean = false;
  isDeletePipeline: boolean = false;
  activeTabIndex: number = 0;
  currentPipelineType: string = 'lead';

  
  items: any[] = [];

  columns: any[] = [
    { field: 'pipeline_name', header: 'Pipeline Name' },
    { field: 'stageCount', header: 'Total Stages', type: 'number' },
    { field: 'set_default', header: 'Default', type: 'boolean' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  tabs: any[] = [
    { label: 'Leads Pipeline', value: 'lead' },
    // { label: 'Admission Pipeline', value: 'admission' }
  ];

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private toast: ToastrService
  ) { }

  ngOnInit(): void {
    this.getPipelines();
  }

  onTabChange(event: any) {
    const index = parseInt(event.value);
    this.activeTabIndex = index;
    this.currentPipelineType = this.tabs[index].value;
    this.getPipelines();
  }

  getMenuItems(rowData: any) {
    return [
      {
        label: 'Options',
        items: [
          {
            label: 'Edit Pipeline',
            icon: 'pi pi-fw pi-pencil',
            command: () => {
              this.isEditPipeline = true;
              this.editPipelineData = rowData;
            }
          },
          {
            label: 'Delete Pipeline',
            icon: 'pi pi-fw pi-trash',
            styleClass: 'delete-menu-item',
            command: () => {
              this.isDeletePipeline = true;
              this.editPipelineData = rowData;
            }
          }
        ]
      }
    ];
  }

  getPipelines() {
    let param = {
      client_id: Number(this.localStorage.getClientId()),
      hospital_id: Number(this.localStorage.getHospitalId()),
      pipeline_type: this.currentPipelineType
    };
    
    this.loading = true;
    this.api.getPipelines(param).subscribe(
      (data: any) => {
        this.initialLoad = false;
        this.loading = false;
        this.dataSource = (data || []).map((pipeline: any) => ({
          ...pipeline,
          stageCount: pipeline.stages?.length || 0
        }));
        this.totalRecords = this.dataSource.length;

        this.filterArray = [
          { key: 'pipeline_name', value: 'Pipeline Name' },
          { key: 'set_default', value: 'Default', type: 'boolean' }
        ];
      },
      (error: any) => {
        this.initialLoad = false;
        this.loading = false;
        this.toast.error(error.error?.message || 'Something went wrong, Please try again later.');
      }
    );
  }

  handleAddPipeline() {
    this.isAddPipeline = true;
  }

  handleCloseDialog() {
    this.isAddPipeline = false;
  }
}
